import axios from 'axios'
import { IS_FREE_PLATFORM, NODE_ENV, REDIRECT_ON } from '.'
// import { trackEvent } from '@src/lib/mixpanel'
import { trackEvent } from '../lib/mixpanel'


export const QA_BACKEND_URL = process.env.REACT_APP_QA_BACKEND_URL as string
const POLOTNO_BACKEND_URL = process.env.REACT_APP_POLOTNO_BACKEND_URL as string

export const polotnoBackendApiInstance = axios.create({
  baseURL: POLOTNO_BACKEND_URL,
  timeout: 10000,
})
const token = localStorage.getItem('accessToken')
export const qaBackendApiInstance = axios.create({
  baseURL: QA_BACKEND_URL,
  timeout: 1000000000,
  headers: {
    Authorization: `Bearer ${token}`, // If you are using token-based auth
  },
})

export const domainLogout = async () => {
  const domainName = window.location.hostname === 'localhost' ? 'dev-aivideos.quickads.ai' : window.location.hostname
  const BE_HANDLE = NODE_ENV === 'dev' ? QA_BACKEND_URL : `${QA_BACKEND_URL}/`
  const response = await axios.get(`${BE_HANDLE}domain/get-domain-names?domain_name=${domainName}&domain_type=video`)
  if (response.status === 200) {
    trackEvent('Sudden Logout', {
      type: 'WARNING',
      variant: 'Video',
      message: 'Video Editor',
      payload: `token is: ${token}`,
      submodule: 'Video',
    })
    // window.location.href = `https://${response?.data?.domain_name}/logout`
  } else {
    console.error('Invalid URL.')
  } 
}

const urlParams = new URLSearchParams(window.location.search)
const userCookieParam = urlParams.get('u')
if (userCookieParam) {
  try {
    const userCookie = JSON.parse(decodeURIComponent(userCookieParam))
    const tokenFromUrl = userCookie?.token
    if (tokenFromUrl) {
      localStorage.setItem('accessToken', tokenFromUrl)
    }
    // Remove 'u' from URL after reading token
    urlParams.delete('u')
    const newUrl = urlParams.toString()
      ? `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`
      : `${window.location.origin}${window.location.pathname}`
    window.history.replaceState({}, document.title, newUrl)
  } catch (error) {
    console.error('Failed to parse userCookie from URL:', error)
  }
}

export function getToken() {
  const token = localStorage.getItem('accessToken')
  const cookie = decodeURIComponent(
    document.cookie
      .split('; ')
      .find((row) => row.startsWith('crossToken'))
      ?.split('=')[1] || ''
  )
  const cookieToken = cookie
    ? JSON.parse(
        decodeURIComponent(
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('crossToken'))
            ?.split('=')[1] || ''
        )
      ).token
    : null

  if (token && cookieToken) {
    if (token && cookieToken === token) {
      return token
    }
    return cookieToken
  }
  if (token) {
    return token
  }
  if (cookieToken) {
    return cookieToken
  }
  // Keep existing localStorage accessToken; don't clear when token not in URL param
  if (!REDIRECT_ON || IS_FREE_PLATFORM === 'false') domainLogout()
}
export function getDomainID() {
  const domainID = localStorage.getItem('domainId') as string
  return domainID
}

// export function getDomainID() {
//   const domainID = localStorage.getItem('domainID')
//   const cookie = decodeURIComponent(
//     document.cookie
//       .split('; ')
//       .find((row) => row.startsWith('domainId'))
//       ?.split('=')[1] || ''
//   )
//   const cookieDomainID = cookie ? cookie : null

//   if (domainID && cookieDomainID) {
//     if (domainID && cookieDomainID === domainID) {
//       return domainID
//     } else {
//       localStorage.setItem('domainID', cookieDomainID)
//       return cookieDomainID
//     }
//   }
//   if (domainID) {
//     return domainID
//   }
//   if (cookieDomainID) {
//     localStorage.setItem('domainID', cookieDomainID)
//     return cookieDomainID
//   }
//   if (!domainID) {
//     throw new Error('User not logged in')
//   }
// }

// Use an interceptor to add the token to each request

qaBackendApiInstance.interceptors.request.use(
  async (config) => {
    const token = await getToken()
    // Only set the Authorization header if the token is present and valid
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      // Optionally, handle the case where there is no valid token
      console.warn('User not logged in.')
      domainLogout()
      // if (!REDIRECT_ON || IS_FREE_PLATFORM === 'false') window.location.href = QUICKADS_REDIRECT_URL
      // Depending on your application's flow, you might want to redirect to login here or handle it some other way
    }
    return config
  },
  (error) => {
    // Handle request error here
    console.error('Request configuration error:', error)
    return Promise.reject(error)
  }
)
